<template>
  <div class="form">
    <div class="form-container">
      <div class="form-radio">
        <span class="type"> 反馈类型</span>
        <van-radio-group v-model="radio"
                         direction="horizontal">
          <van-radio name="5">
            投诉
            <template #icon="props">
              <img class="img-icon"
                   :src="props.checked ? activeIcon : noActiveIcon" />
            </template>
          </van-radio>
          <van-radio name="3">
            建议
            <template #icon="props">
              <img class="img-icon"
                   :src="props.checked ? activeIcon : noActiveIcon" />
            </template>
          </van-radio>
        </van-radio-group>
      </div>
      <div class="form-text">
        <van-field v-model="message"
                   rows="2"
                   autosize
                   type="textarea"
                   maxlength="200"
                   placeholder="描述你的问题"
                   show-word-limit />
      </div>
    </div>
    <div class="phone">
      <van-field v-model="qq"
                 placeholder="请输入您的联系方式(手机号、QQ、微信)" />
    </div>
    <div class="submit">
      <div class="sub-btn"
           @click="submit ">提交</div>

    </div>
  </div>

</template>

<script>
import Vue from 'vue';
import http from '../utils/http.js';
import { countClick } from "../common/mixin"
import { Toast } from 'vant';
import axios from 'axios';
Vue.use(Toast);
export default {
  name: 'index',
  mixins: [countClick], // 混入 
  data () {
    return {
      radio: "5",
      message: '',
      qq: "",
      activeIcon: require('../assets/images/activeIcon.png'),
      noActiveIcon: require('../assets/images/noActiveIcon.png'),

    }
  },
  mounted () {
    document.title = "投诉建议";

  },
  methods: {
    submit () {
      if (this.message == "") {
        this.$toast({
          message: '请填写问题描述',
          position: 'top',
        });;
        return false;
      } else {
        let url = "/FeedBack/Submit";
        let radio = Number(this.radio);
        let typeName = "";
        if (radio === 5) {
          typeName = "投诉";
        } else {
          typeName = "建议";
        };
        var params = {
          type: radio,
          content: this.message,
          contact: this.qq,
          typeName: typeName
        };
        http.postForm(url, params).then(res => {
          if (res.data.code == 0) {
            this.$toast({
              message: '提交成功！',
              position: 'top',
            });
          } else {
            this.$toast({
              message: res.data.message,
              position: 'top',
            });;
          }
        })
      }

    }


  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style   scoped>
.form {
  width: 100%;
  overflow: hidden;
  position: absolute;
  top: 0;
  bottom: 0;
  background-color: #ededed;
}
.form .form-container {
  padding: 0 16px 0 16px;
  background: #fff;
  position: relative;
  top: 0;
  left: 0;
}
.form .form-container .form-radio {
  position: relative;
  top: 0;
  left: 0;
  padding-top: 16px;
  padding-bottom: 16px;
  display: flex;
  font-size: 16px;
  color: #333 !important;
}
.form >>> .van-radio__label {
  color: #333;
}
.form .form-container .form-radio::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 108%;
  height: 1px;
  background-color: #e6e6e6;
  opacity: 0.5;
}
.form .form-container .form-radio .type {
  padding-right: 44px;
}
.form >>> .van-radio--horizontal {
  margin-right: 32px;
}
.form .form-text {
  padding-top: 16px;
}
.form >>> .van-cell {
  padding: 0;
}
.form >>> .form-container .van-field__control {
  height: 88px !important;
  line-height: 22px;
}
.form >>> .van-field__word-limit {
  color: #999;
  margin-top: 0;
  line-height: 34px;
}
.form .phone {
  margin-top: 10px;
  width: 100%;
  height: 56px;
  line-height: 56px;
  background-color: #fff;
  padding: 16px;
}
.form .phone >>> .van-field__body {
  font-size: 16px;
}
.submit {
  padding-top: 80px;
  padding-left: 16px;
  padding-right: 16px;
}
.submit .sub-btn {
  width: 100%;
  height: 44px;
  line-height: 44px;
  background: #3b75ff;
  border-radius: 4px;
  color: #fff;
  font-size: 16px;
}
.form-radio img {
  display: inline-block;
  width: 18px;
  height: 18px;
}
</style>



// WEBPACK FOOTER //
// src/pages/form.vue